import React from "react";
import { useTranslation } from "react-i18next";
import { Body2, Button } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

export const VersionHeader = ({ className, onClick, versionId }) => {
  const { t } = useTranslation();

  const text =
    versionId > 1
      ? t(`Showing changes between version #${versionId - 1} and version #${versionId}`)
      : t("Showing original note");

  return (
    <div
      className={classNames(
        "tw-flex tw-items-center tw-justify-between tw-border-border-primary tw-border-0 tw-border-solid tw-border-b tw-pb-6 tw-mb-6",
        className
      )}
    >
      <Body2
        weight="medium"
        color="tertiary"
      >
        {text}
      </Body2>
      <Button
        variant="secondary"
        size="small"
        onClick={onClick}
      >
        {t("Exit Versions")}
      </Button>
    </div>
  );
};

VersionHeader.propTypes = {
  versionId: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
};
